<script setup>
import { watch } from "vue";
import { useRouter } from "vue-router";
import { useAuth0 } from "@auth0/auth0-vue";

const { loginWithPopup, logout, isAuthenticated } = useAuth0();
const router = useRouter();
const handleLogin = async () => {
  try {
    await loginWithPopup();
  } catch (e) {}
};
const handleLogout = () => {
  logout({ logoutParams: { returnTo: window.location.origin } });
};

if (isAuthenticated.value) router.push("home");

watch(
  () => isAuthenticated.value,
  (status) => {
    if (status) router.push("home");
  }
);
</script>

<template>
  <div class="grid-x cell small-12">
    <div class="cell medium-2 large-3"></div>
    <div class="text-wrapper cell small-12 medium-8 large-6">
      <h1 id="welcome">Welcome to Blythings!</h1>
    </div>
    <div class="cell medium-2 large-3"></div>

    <div class="cell medium-2 large-3"></div>

    <div class="cell text-wrapper small-12 medium-8 large-6 center-align">
      <div v-if="!isAuthenticated" class="btn" @click="handleLogin">Login</div>
      <div v-else class="btn" @click="handleLogout">Logout</div>
    </div>

    <div class="cell medium-2 large-3"></div>
  </div>
</template>

<style lang="scss">
@use "@/assets/styles/abstract/variables" as *;

/// Stroke font-character
/// @param  {Integer} $stroke - Stroke width
/// @param  {Color}   $color  - Stroke color
/// @return {List}            - text-shadow list
@function stroke($stroke, $color) {
  $shadow: (
  );
$from: $stroke * -1;

@for $i from $from through $stroke {
  @for $j from $from through $stroke {
    $shadow: append($shadow, $i * 1px $j * 1px 0 $color, comma);
  }
}

@return $shadow;
}

/// Stroke font-character
/// @param  {Integer} $stroke - Stroke width
/// @param  {Color}   $color  - Stroke color
/// @return {Style}           - text-shadow
@mixin stroke($stroke, $color) {
  text-shadow: stroke($stroke, $color);
}

h1,
h2,
h3 {
  color: $orange;
  font-family: "Quicksand", sans-serif;
  -webkit-text-fill-color: $orange;
  -webkit-text-stroke-color: $orange;
  -webkit-text-stroke-width: 0.03em;
  text-align: center;
}

h1#welcome {
  font-size: 7cqmin;
  margin: 0;
}

h2 {
  font-size: 5cqmin;
}

h3 {
  font-size: 2.5em;
}

.text-wrapper {
  background: $transparent-light;
  border-radius: 16px 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(6.1px);
  -webkit-backdrop-filter: blur(6.1px);
  border: 1px solid rgba(125, 40, 40, 0.2);
  padding: 20px;
  margin: 15px 0;

  @include mobile {
    background: $transparent-light-mobile;
  }
}
</style>
